import {
  Activity,
  Archive,
  Bot,
  CalendarClock,
  Cloud,
  Database,
  GitBranch,
  Home,
  Inbox,
  Layers,
  ListChecks,
  Network,
  Palette,
  Radio,
  Scale,
  Search,
  Settings,
  Target,
  Terminal,
  User,
  Zap,
} from "lucide-react";
import type { JSX } from "react";
import type { StudioDestination } from "./navigation";

const ICONS: Record<StudioDestination["icon"], (props: { size?: number }) => JSX.Element> = {
  home: (p) => <Home size={p.size ?? 16} aria-hidden="true" />,
  activity: (p) => <Activity size={p.size ?? 16} aria-hidden="true" />,
  bot: (p) => <Bot size={p.size ?? 16} aria-hidden="true" />,
  cloud: (p) => <Cloud size={p.size ?? 16} aria-hidden="true" />,
  network: (p) => <Network size={p.size ?? 16} aria-hidden="true" />,
  layers: (p) => <Layers size={p.size ?? 16} aria-hidden="true" />,
  database: (p) => <Database size={p.size ?? 16} aria-hidden="true" />,
  target: (p) => <Target size={p.size ?? 16} aria-hidden="true" />,
  zap: (p) => <Zap size={p.size ?? 16} aria-hidden="true" />,
  radio: (p) => <Radio size={p.size ?? 16} aria-hidden="true" />,
  inbox: (p) => <Inbox size={p.size ?? 16} aria-hidden="true" />,
  "git-branch": (p) => <GitBranch size={p.size ?? 16} aria-hidden="true" />,
  "calendar-clock": (p) => <CalendarClock size={p.size ?? 16} aria-hidden="true" />,
  archive: (p) => <Archive size={p.size ?? 16} aria-hidden="true" />,
  terminal: (p) => <Terminal size={p.size ?? 16} aria-hidden="true" />,
  scale: (p) => <Scale size={p.size ?? 16} aria-hidden="true" />,
  search: (p) => <Search size={p.size ?? 16} aria-hidden="true" />,
  "list-checks": (p) => <ListChecks size={p.size ?? 16} aria-hidden="true" />,
  settings: (p) => <Settings size={p.size ?? 16} aria-hidden="true" />,
  user: (p) => <User size={p.size ?? 16} aria-hidden="true" />,
  palette: (p) => <Palette size={p.size ?? 16} aria-hidden="true" />,
};

export function destinationIcon(icon: StudioDestination["icon"], size = 16): JSX.Element {
  return ICONS[icon]({ size });
}
